<template lang="html">

    <section class="login">
        <v-content>
            <h1 class="mb-5 mt-5">Sign In</h1>
            <v-form v-model="valid" ref="form">
                <v-text-field outlined v-model="email" label="Email" :rules="[rules.required, rules.mail]" validate-on-blur></v-text-field>
                <v-text-field
                        outlined
                        v-model="password"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        hint="At least 8 characters"
                        counter
                        @click:append="show = !show"
                        validate-on-blur
                ></v-text-field>
                <p class="red--text" v-for="message in errorMessages" v-bind:key="message">{{message}}<br></p>
              <p>Don't have an account? <router-link to="/signup">Sign Up</router-link><br></p>
              <p>Forgot Password? <router-link to="/password/forgot">Reset</router-link><br></p>
                <v-btn @click="login" class="button">Login</v-btn>
            </v-form>
        </v-content>
    </section>

</template>

<script lang="js">
    import Vue from 'vue'
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    import Vuex from 'vuex'
    import VueRouter from 'vue-router'

    Vue.use(VueAxios, axios, Vuex, VueRouter);
    export default {
        name:     'login',
        props:    ['url'],
        mounted () {

        },
        data () {
            return {
                'email':       "",
                'password':    "",
                show:          false,
                errorMessages: [],
                valid:         false,
                rules:         {
                    required:   value => !!value || 'Required.',
                    min:        v => v.length >= 8 || 'At least 8 characters',
                    mail:       v => /.+@.+\..+/.test(v) || 'Please enter a valid email address',
                },
            }
        },
        methods:  {
            login () {
                if (this.valid) {
                    this.errorMessages = [];
                    let formData       = new FormData();
                    formData.append('email', this.email);
                    formData.append('password', this.password);

                    // this.axios.post(this.url + "/api/auth/login", formData)
                    //     .then(res => {
                    //         this.store.commit('LOGIN_SUCCESS', res.access_token);
                    //     })
                    //     .catch(err => console.log(err));
                    this.$store.dispatch('auth/login', formData).then(res => {
                        console.log(res);
                        if (this.$router.currentRoute.path !== "/") {
                            this.$router.push("/");
                        }
                        this.$emit('login');
                    }).catch(err => {
                        console.log(err.response);
                        if (err.response.data.errors) {
                            const errors = Object.values(err.response.data.errors);
                            errors.forEach(errorCategory => {
                                errorCategory.forEach(error => {
                                    this.errorMessages.push(error);
                                });
                            });
                        } else if (err.response.data.message) {
                            this.errorMessages.push(err.response.data.message);
                        }
                    });
                } else {
                    this.$refs.form.validate();
                }
            }
        },
        computed: {}
    }


</script>

<style scoped lang="scss">
    .login {

    }
</style>
